import { fromJS } from 'immutable';
import _ from 'lodash';
import * as incomeModelActions from '../actions/incomeModels';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import { fetchingState } from '@constants';

const updateStateArrayItem = (state, data, arrayName, idFieldName) =>
  state.setIn(
    [arrayName, 'data'],
    fromJS(
      state
        .getIn([arrayName, 'data'])
        .toJS()
        .map(x =>
          x[idFieldName] === _.get(data, `results[0].${idFieldName}`)
            ? data.results[0]
            : x,
        ),
    ),
  );

const initialState = {
  pricingSchedules: {
    data: [],
    count: null,
    state: null,
  },
  codeFiles: {
    data: {},
    state: null,
  },
  filters: {}
};

export default (
  state = fromJS(initialState),
  { type, data, pricingScheduleId, name, payload },
) => {
  let newState;
  switch (type) {
    case incomeModelActions.FETCH_PRICING_SCHEDULES[START]:
      return state.setIn(['pricingSchedules', 'state'], fetchingState.FETCHING);

    case incomeModelActions.FETCH_PRICING_SCHEDULES[SUCCESS]:
      newState = state.setIn(
        ['pricingSchedules', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['pricingSchedules', 'count'],
        data ? data.totalSchedules.incomePricingScheduleCount : 0,
      );
      return newState.setIn(
        ['pricingSchedules', 'data'],
        fromJS(data ? data.results : []),
      );
    case incomeModelActions.FETCH_PRICING_SCHEDULES[ERROR]:
      return state.setIn(['pricingSchedules', 'state'], fetchingState.ERROR);

    case incomeModelActions.FETCH_PRICING_SCHEDULE[SUCCESS]:
      const schedules = state.getIn(['pricingSchedules', 'data'], []).toJS();
      if (
        schedules.some(
          s => s.incomePricingID === data.results[0].incomePricingID,
        )
      ) {
        return updateStateArrayItem(
          state,
          data,
          'pricingSchedules',
          'incomePricingID',
        );
      }
      return state.setIn(
        ['pricingSchedules', 'data'],
        fromJS([
          ...state.getIn(['pricingSchedules', 'data']).toJS(),
          ...(data ? data.results : []),
        ]),
      );

    case incomeModelActions.UPDATE_PRICING_SCHEDULE[SUCCESS]:
    case incomeModelActions.UPDATE_PRICING_SCHEDULE_TAGS[SUCCESS]:
      return updateStateArrayItem(
        state,
        data,
        'pricingSchedules',
        'incomePricingID',
      );

    case incomeModelActions.DELETE_PRICING_SCHEDULE[SUCCESS]:
      return state.setIn(
        ['pricingSchedules', 'data'],
        fromJS(
          state
            .getIn(['pricingSchedules', 'data'])
            .toJS()
            .filter(p => p.incomePricingID !== pricingScheduleId),
        ),
      );

    case incomeModelActions.INSERT_PRICING_SCHEDULE[SUCCESS]:
      return state.setIn(
        ['pricingSchedules', 'data'],
        fromJS([
          ...state.getIn(['pricingSchedules', 'data']).toJS(),
          ...(data ? data.results : []),
        ]),
      );

    case incomeModelActions.FETCH_CODE_FILE[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', name],
        fromJS(data ? data.results : []),
      );

    case incomeModelActions.FETCH_GPR_ADJ_TYPES[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', 'gprAdjTypes'],
        fromJS(data ? data.results : []),
      );

    case incomeModelActions.FETCH_EXPENSE_TYPES[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', 'expenseTypes'],
        fromJS(data ? data.results : []),
      );

    case incomeModelActions.SET_INCOME_MODEL_FILTERS:
      if (Object.keys(payload).length === 0) {
        return state.set('filters', {});
      }
      return state.mergeIn(['filters'], payload);

    default:
      return state;
  }
};
